/**
 * Coach matching-details server functions (expertise, audience, approach).
 *
 * Aliases: coach details, discovery details, expertise options
 */

import { createServerFn } from "@tanstack/react-start";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import { CoachDetailsSchema } from "~/lib/shared/schemas/coach-details";

export const getCoachDetailsData = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .handler(async ({ context }) => {
    const { getCoachMatchingDetails } =
      await import("~/lib/server/coach-matching-details");

    return getCoachMatchingDetails(context.coach);
  });

export const getExpertiseOptions = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .handler(async () => {
    const { getExpertiseSubcategories } =
      await import("~/lib/server/expertise");

    return getExpertiseSubcategories();
  });

export const saveCoachDetails = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .validator((data: unknown) => CoachDetailsSchema.parse(data))
  .handler(async ({ data, context }) => {
    const { saveCoachMatchingDetails } =
      await import("~/lib/server/coach-matching-details");

    return saveCoachMatchingDetails(context.coach, data);
  });
